import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Loader de marca reutilizable.
 * - screen: carga inicial, chunks de ruta y autenticación.
 * - panel: carga de datos dentro de una vista.
 * - inline: acciones pequeñas sin bloquear la pantalla.
 */
export default function MatchBotLoader({
  variant = "screen",
  label,
  className = "",
}) {
  const { t } = useTranslation("common");
  const resolvedLabel = label || t("loader.preparing");
  const isScreen = variant === "screen";
  const isInline = variant === "inline";

  return (
    <div
      className={`matchbot-loader matchbot-loader--${variant} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={resolvedLabel}
    >
      <div className="matchbot-loader__visual" aria-hidden="true">
        <span className="matchbot-loader__orbit matchbot-loader__orbit--outer" />
        <span className="matchbot-loader__orbit matchbot-loader__orbit--inner" />
        <span className="matchbot-loader__pulse" />
        <span className="matchbot-loader__logo-shell">
          <img
            src="/brand/matchbot-logo-192.png"
            alt=""
            className="matchbot-loader__logo"
          />
        </span>
      </div>

      {!isInline && (
        <div className="matchbot-loader__copy">
          {isScreen && (
            <span className="matchbot-loader__brand">
              MATCH<span>BOT</span>
            </span>
          )}
          <span className="matchbot-loader__label">{resolvedLabel}</span>
          <span className="matchbot-loader__progress" aria-hidden="true">
            <span />
          </span>
        </div>
      )}
    </div>
  );
}
